import { render, staticRenderFns } from "./branchCode.vue?vue&type=template&id=21e82066&scoped=true&"
import script from "./branchCode.vue?vue&type=script&lang=js&"
export * from "./branchCode.vue?vue&type=script&lang=js&"
import style0 from "./branchCode.vue?vue&type=style&index=0&id=21e82066&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e82066",
  null
  
)

export default component.exports